import React from 'react';

import { Clock, CloseCircle, Refresh2, TickCircle } from '@myua/icons/dist/linear16';

import { CHNodePlotRecognitionStatus } from '../../../../../general/node';
import { PlotRecognitionStatus } from '../../../../../general/modelPlotRecognition';
import { Type } from '../../../../../general/modules/filter/dataModel';
import { FileManagerRow, FMColumn } from '../../model';
import { PlotRecognitionPopover } from './PlotRecognitionPopover';

import './styles.scss';

const ICONS: Record<PlotRecognitionStatus, React.ReactNode> = {
  pending: <Clock className="ch-recognition__icon ch-recognition__icon-pending" />,
  processing: <Refresh2 className="ch-recognition__icon ch-recognition__icon-processing" />,
  success: <TickCircle className="ch-recognition__icon ch-recognition__icon-success" />,
  error: <CloseCircle className="ch-recognition__icon ch-recognition__icon-error" />,
};

/**
 * Статус AI-разметки сюжета у папки-креатива (MYUA-16736). Данные — с самой ноды листинга,
 * поэтому ячейке не нужен WithLoader: значение есть сразу после загрузки списка.
 *
 * При `success` статус кликабелен и открывает тот же read-only поповер с разметкой, что и
 * иконка-робот в столбце `Name`. В остальных статусах (в том числе `error`) показывать нечего,
 * поэтому значение остаётся обычным текстом.
 */
export const RecognitionCellInner: React.FC<{
  rowData: FileManagerRow;
  column: FMColumn<Type.ID>;
}> = ({ rowData, column }) => {
  const status = CHNodePlotRecognitionStatus(rowData);
  if (status === null) {
    return <span></span>;
  }

  const label = column.toDisplayString(rowData) ?? '';
  const content = (
    <>
      {ICONS[status]}
      {label}
    </>
  );

  if (status !== 'success') {
    return (
      <span className="conversion-status-error__item" title={label}>
        {content}
      </span>
    );
  }

  return (
    <PlotRecognitionPopover
      nodeId={rowData.id}
      className="conversion-status-error__item ch-recognition__trigger"
      ariaLabel="Show AI metadata"
    >
      {content}
    </PlotRecognitionPopover>
  );
};
